import {Card} from 'platform/components';
import {Heading, Space, Stack, Text, VStack} from 'platform/foundation';

interface SectionCardProps {
  title: string;
  subtitle: string;
  children: React.ReactNode;
}

export function SectionCard(props: SectionCardProps) {
  return (
    <VStack spacing={4}>
      <Stack
        direction={['column', 'column', 'row', 'row']}
        align={['flex-start', 'flex-start', 'center', 'center']}
        justify="space-between"
        spacing={4}
      >
        <VStack maxWidth="60%">
          <Heading size={2}>{props.title}</Heading>
          <Space vertical={1} />
          <Text size="base" color="secondary">
            {props.subtitle}
          </Text>
        </VStack>
      </Stack>
      <Card>{props.children}</Card>
    </VStack>
  );
}
